import { css, keyframes } from '@emotion/css'

const dinoSize = 55

const dinoRun = keyframes({
  '0%': {
    left: '0%',
    opacity: 1,
  },
  '60%': {
    opacity: 1,
  },
  '80%': {
    left: '100%',
    opacity: 0,
  },
  '81%': {
    opacity: 0,
    left: '100%',
  },
  '82%': {
    opacity: 0,
    left: '-20%',
  },
  '98%': {
    opacity: 0,
  },
  '99%': {
    opacity: 1,
  },
  '100%': {
    left: '0%',
  },
})

const blinkDino = keyframes({
  '0%': {
    opacity: 1,
  },
  '50%': {
    opacity: 1,
  },
  '51%': {
    opacity: 0,
  },
  '100%': {
    opacity: 0,
  },
})

const styles = {
  animationTrigger: css({
    position: 'relative',
    display: 'block',
    cursor: 'pointer',
    height: dinoSize,
    padding: 0,
    margin: 0,
    border: 0,
    background: 'unset',
  }),

  dinoRun: css({
    animation: `${dinoRun} 5s linear`,
  }),

  dinoStep1: css({
    display: 'block',
    position: 'absolute',
    transform: 'translateY(-50%)',
  }),

  dinoStep2: css({
    display: 'block',
    position: 'absolute',
    transform: 'translateY(-50%)',
    opacity: 0,
  }),

  dinoStep1Animation: css({
    animation: `${blinkDino} 0.4s linear infinite`,
  }),

  dinoStep2Animation: css({
    animation: `${blinkDino} 0.4s linear 0.2s infinite`,
  }),
}

export default styles
